import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgress } from '@material-ui/core';

const Loading = (props) => (
  <div
    className="container-fluid d-flex flex-column justify-content-center align-items-center"
    style={{
      position:        'fixed',
      top:             0,
      left:            0,
      right:           0,
      width:           '100%',
      height:          '100vh',
      zIndex:          props.zIndex,
      backgroundColor: props.backgroundColor,
    }}
  >
    <CircularProgress color="secondary" />
  </div>
);

Loading.propTypes = {
  backgroundColor: PropTypes.string,
  zIndex:          PropTypes.number,
};

Loading.defaultProps = {
  backgroundColor: '#000000aa',
  zIndex:          99,
};

export default Loading;
